
import React from "react";
import Index from "./routers/index";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 

function App() {
  return (
    <div>
      <ToastContainer position='top-center' /> 
      <Index /> 
    </div>
  );
}

export default App;

